import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareProformaIssueFormsDirectEmbedRoute: InvariantJiraRoute = {
	name: 'software-proforma-issue-forms-direct-embed',
	path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
	exact: true,
};
